import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetCurrentPreferencesPeriod = () => {
  const query = useApiQuery(
    ['courseAssignmentPeriod'],
    'schools',
    '/current-enrollment/course-assignment/period',
    {},
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    period: query.data?.period ?? null,
    classmates: query.data?.classmates ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
